<template>
  <div class="items file-box" :name="selectData.elementCode" :data-path="selectData.elementPath">
    <div class="items-wrap">
      <span class="lables">{{selectData.elementName}}</span>
      <div class="from-right">
        <van-uploader :after-read="update" :before-read="beforeRead">
          <van-button
            icon="photo"
            type="primary"
            :loading="uploadStatus"
            :loading-text="uploadTxt"
            color="linear-gradient(to bottom, #93f9b9 , #1d976c)"
          >上传文件</van-button>
        </van-uploader>
        <van-button
        v-show="tableData && tableData.length>0"
          type="info"
          @click="showTable=true"
          color="linear-gradient(to bottom, #00d2ff , #0084ff)"
        >查看结果</van-button>
      </div>
    </div>
    <van-popup v-model="showTable" position="bottom" round :style="{ height: '70%' }">
      <div class="file-top">
          文件预览
          <i class="iconfont iconchuyidong" @click="showTable=false"></i>
        </div>
      <div class="file-layer-box" v-if="tableData && tableData.length>0">
        <div class="file-table" :style="{width:tableData[0].length*2.4+'rem'}">
          <div class="file-table-head">
            <div class="file-table-tr">
              <div class="file-table-th" v-for="item in tableData[0]">{{item}}</div>
            </div>
          </div>
          <div class="file-table-content">
            <div class="file-table-tr" v-if="i>0" v-for="(item,i) in tableData">
              <div class="file-table-td" v-for="child in item">{{child}}</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    selectData: {
      type: Object
    }
  },
  data() {
    return {
      uploadStatus: false, //上传状态
      uploadTxt: '', //上传文案
      max: 1,
      showTable: false,
      tableData: [], //表格数据
      params:{},//上传参数
    };
  },
  mounted() {},
  methods: {
    // 文件上传前识别文件类型
    beforeRead(file) {
      console.log(file);
      let fileBlank = "xlsx,xls";
      var ext = file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase();
      if (ext.indexOf("xls") != 0) {
        this.$notice.msg("您上传的不是excel格式的文件！");
        return false;
      }
      return true;
    },
    /**
     * 上传图片
     */
    update(file) {
      this.uploadStatus = true;
      this.uploadTxt = "上传中...";
      let param = new FormData(); //创建form对象
      param.append("file", file.file, file.file.name); //通过append向form对象添加数据
      this.$http({
        url: "/insure/readData",
        data: param,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
        .then(data => {
          console.log(data);
          this.tableData=data.data;
          this.uploadStatus = false;
          this.uploadTxt = "";
          this.getResult();
        })
        .catch(err => {
          this.uploadStatus = false;
          this.uploadTxt = "";
        });
    },
    getResult() {
      let value = this.tableData;
      if (value.length == 0) {
        value = null;
      }
      this.selectData.elementValue = value;
      this.$emit("selected", {
        type: 1,
        item: this.selectData,
        value: value
      });
    }
  },
  watch: {
    files(newVal) {
      if (newVal.length == 0) {
        this.fileList = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.verify-box {
  padding-left: 230px;
  padding-bottom: 5px;
  .verify-title {
    font-size: 30px;
    color: #333;
  }
  .verify-li {
    font-size: 28px;
    color: #666;
    line-height: 1.4;
    padding: 3px 0;
    border-bottom: 1px dashed #ececec;
    word-break: break-all;
  }
}
.van-button--normal {
  vertical-align: middle;
  margin-right: 5px;
}
.van-button {
  border-radius: 4px;
}
.file-layer-box{
  position: relative;
  padding-top: 80px;
  width: 100%;
  height: 100%;
  overflow-x: scroll;
  overflow-y: auto;
  padding-bottom: 15px;
}
.file-top{
    width: 100%;
    height: 80px;
    position: absolute;
    left: 0;
    top: 0;
    font-size: 30px;
    line-height: 80px;
    text-align: center;
    background-color: #fff;
    z-index: 2;
    .iconfont{
      position: absolute;
      right: 20px;
      top: 0;
      font-size: 50px;
    }
  }
.file-table {
  display: table;
  font-size: 28px;
  .file-table-head{
    display: table-header-group;
  }
  .file-table-content{
    display: table-row-group;
  }
  .file-table-tr {
    display: table-row;
  }
  .file-table-th,
  .file-table-td {
    display: table-cell;
    min-width: 150px;
    padding: 5px 10px;
    line-height: 40px;
    text-align: center;
  }
  .file-table-th {
    font-size: 30px;
    border-bottom: 1px solid #ececec;
  }
}
</style>
